module.exports = __webpack_public_path__ + "img/PDV_bw.c456ce8a.jpg";